module.exports = __webpack_public_path__ + "img/V-R-4-load-connect-shadow.a1b181c1.png";